
















import Vue from "vue";

// Import External Components
import BreadCrumb from "@miele/component-library-vue/src/components/modules/pages/BreadCrumb.vue";
import Loader from "@/components/Loader.vue";

export default Vue.extend({
  name: "App",
  components: {
    BreadCrumb,
    Loader,
  },
  data() {
    return {
      prevHeight: "0",
    };
  },
  computed: {
    loading() {
      var body = document.body;

      if (this.$store.state.loading) {
        body.classList.add("loading");
      } else {
        body.classList.remove("loading");
      }
      return this.$store.state.loading;
    },
    entries() {
      const route = this.$route;
      const recipeCopy = this.$store.state.translations.recipesCopy;
      const breadCrumbs: any = [];
      const jsonBreadCrumbs = this.$store.getters.getbreadCrumbs;
      if (jsonBreadCrumbs) {
        breadCrumbs.push(...jsonBreadCrumbs);
        if (route.name !== "Index") {
          const homeRoute = {
            name: recipeCopy,
            link: "/",
          };
          const currentRoute = {
            name: route.params.title,
            link: "#",
          };
          breadCrumbs.push(...[homeRoute, currentRoute]);
          return breadCrumbs;
        } else {
          const currentRoute = {
            name: recipeCopy,
            link: "#",
          };
          breadCrumbs.push(currentRoute);
          return breadCrumbs;
        }
      } else {
        return breadCrumbs;
      }
    },
  },
  methods: {
    beforeLeave(element: any) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element: any) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element: any) {
      element.style.height = "auto";
    },
  },
});
